<p-dialog
  header="Deletion Remarks"
  [(visible)]="deleteRecord"
  modal="modal"
  width="500"
>
  <ara-textarea
    [sourceText]="deletionReason"
    [maxLength]="1000"
    disabled="false"
    (output)="getRemarks($event, 'DeletionReason', 0)"
  ></ara-textarea>
  <div *ngIf="showDeletionmsg">
    <span class="error-msg-colour">{{
      "ACTIONTRACKER.PLEASE_ENTER_DELETION_REMARKS." | translate
    }}</span>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="deleteAction(deleteActionId)"
      label="Submit"
      class="active-btn orange-btn"
    ></button>
    <button
      type="button"
      pButton
      (click)="onCancelClick()"
      label="Cancel"
      class="active-btn orange-btn"
    ></button>
  </p-footer>
</p-dialog>
<p-dialog
  header="Cancellation Remarks"
  [(visible)]="cancelRecord"
  modal="modal"
  width="500"
>
  <ara-textarea
    [sourceText]="cancellationReason"
    [maxLength]="1000"
    disabled="false"
    (output)="getRemarks($event, 'CancellationReason', 0)"
  ></ara-textarea>
  <div *ngIf="showCancellationmsg">
    <span class="error-msg-colour">{{
      "ACTIONTRACKER.PLEASE_ENTER_CANCELLATION_REMARKS." | translate
    }}</span>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="cancelAction(cancelActionId)"
      label="Submit"
      class="active-btn orange-btn"
    ></button>
    <button
      type="button"
      pButton
      (click)="onCancel()"
      label="Cancel"
      class="active-btn orange-btn"
    ></button>
  </p-footer>
</p-dialog>
<ara-side-nav
  class="inside-topnav"
  [routesFlag]="routesFlag"
  [reportRoutes]="reportRoutes"
></ara-side-nav>
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Incident</a>
      </li>
    </ol>

    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <h3 class="page-title obs-card-title" style="text-align: center">
          <span class="page-sub-title">
            <ng-container *ngIf="incidentId > 0"
              >Incident {{ incidentId }}</ng-container
            >
            <ng-container *ngIf="incidentId === 0"
              >Initial Notification
            </ng-container>
          </span>
          <button
            *ngIf="incidentId > 0"
            (click)="isNext ? onNextClick() : $event.preventDefault()"
            [ngClass]="isNext ? 'cursor-pointer' : 'disabled'"
            class="pull-right btn btn-primary primary-btn"
          >
            <i class="fa fa-angle-right"></i>
          </button>
          <button
            *ngIf="incidentId > 0"
            (click)="isPrevious ? onPreviousClick() : $event.preventDefault()"
            [ngClass]="isPrevious ? 'cursor-pointer' : 'disabled'"
            class="pull-right btn btn-primary primary-btn"
          >
            <i class="fa fa-angle-left"></i>
          </button>

          <div class="clearfix"></div>
        </h3>
        <div class="section-wrapper right">
          <span class="mandatory-info">
            Fields marked with
            <span class="mandatory">*</span> are mandatory
          </span>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >Unit
              <i
                class="fa fa-info-circle"
                pTooltip="Unit are enabled for interaction based on permission of User"
              ></i
              ><span class="mandatory"> *</span></span
            >
            <p-tree
              [value]="unitTree"
              selectionMode="single"
              (onNodeSelect)="nodeSelected($event)"
              [(selection)]="selectedUnit"
              [styleClass]="disableIncident ? 'disabled' : 'cursor-pointer'"
            ></p-tree>
            <span class="error-msg-colour" *ngIf="unitError"
              >Please select unit</span
            >
          </div>

          <div class="sub-section-wrapper" [hidden]="isUnitEmployee">
            <span class="section-sub-title"
              >Contract Number <span class="mandatory">*</span></span
            >
            <!-- <input type="text" maxlength="50" value="" class="form-control margin-top-10" id="name"
              [(ngModel)]="ContractNumber" placeholder="Contract Number"
              [disabled]="true"> -->
            <p-dropdown
              [options]="contracts"
              placeholder="Select"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedContract"
              (onChange)="checkHolder($event)"
            >
            </p-dropdown>
            <span class="error-msg-colour" *ngIf="showContractValidation"
              >Please select Contract Number
            </span>
            <span class="error-msg-colour" *ngIf="!isHasContractDetails"
              >Contract Holder is not available for this contract. Please
              contact admin to update these details.
            </span>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{
                "INCIDENT.ACTIVITY_TAKING_PLACE_AT_THE_TIME_OF_THE_INCIDENT"
                  | translate
              }}
              <span class="mandatory">*</span></span
            >
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="
                incidentRequest.IncidentRequest.ActivityTakingAtIncident
              "
              [maxLength]="1000"
              [disabled]="disableIncident"
              (output)="getRemarks($event, 'ActivityTakingAtIncident', 0)"
            ></ara-textarea>
            <div
              *ngIf="
                incidentRequest.IncidentRequest.ActivityTakingAtIncident
                  .length >= 999
              "
            >
              <span class="error-msg-colour">
                You can enter upto 1000 characters.
              </span>
            </div>
            <div
              *ngIf="
                isIncidenttakingErrorMsg &&
                !incidentRequest.IncidentRequest.ActivityTakingAtIncident
              "
            >
              <span class="error-msg-colour">
                Kindly enter the activity taking place at the time of the
                incident.
              </span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.INCIDENT_REPORTED_BY" | translate }}

              <span class="mandatory">*</span>
            </span>
            <p-autoComplete
              [(ngModel)]="selectedUserEmp"
              [suggestions]="userResults"
              appendTo="body"
              (completeMethod)="getUsersOnSearch($event)"
              placeholder="Employee Name"
              field="FullName"
              [minLength]="1"
              [style]="{ width: '100%' }"
              [inputStyle]="{ width: '100%' }"
              [forceSelection]="true"
              [disabled]="disableIncident"
            >
              <ng-template let-employee pTemplate="item">
                <span [title]="employee.Email">{{ employee.FullName }}</span>
              </ng-template>
            </p-autoComplete>
            <div *ngIf="isIncidentReportErrorMsg && !selectedUserEmp">
              <span style="color: red">{{
                "INCIDENT.KINDLY_SELECT_EMPLOYEE_NAME." | translate
              }}</span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ "INCIDENT.DATE " | translate }}
              &amp;
              {{ "INCIDENT.TIME" | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-calendar
              [showIcon]="true"
              dateFormat="dd/mm/yy"
              [maxDate]="dateTime"
              [showTime]="true"
              [(ngModel)]="incidentRequest.IncidentRequest.IncidentDate"
              class="custom-datepicker"
              readonlyInput="true"
              [disabled]="disableIncident"
              monthNavigator="true"
              yearNavigator="true"
              yearRange="1950:2100"
            >
            </p-calendar>
            <div
              *ngIf="
                isIncidentDateErrorMsg &&
                !incidentRequest.IncidentRequest.IncidentDate
              "
            >
              <span class="error-msg-colour">{{
                "INCIDENT.KINDLY_ENTER_DATE_AND_TIME_OF_THE_INCIDENT."
                  | translate
              }}</span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.LOCATION" | translate }}
              <span class="mandatory">*</span></span
            >
            <p-dropdown
              [options]="locations"
              placeholder="Select"
              [(ngModel)]="selectedLocation"
              [style]="{ width: '100%' }"
              (onChange)="saveLocation()"
              [disabled]="
                disableIncident ||
                (incidentRequest.IncidentRequest.IncidentRequestId > 0 &&
                  incidentRequest.IncidentRequest.Status !== 'Draft' &&
                  isInactiveLocation &&
                  !independentPermissions.APP_Admin &&
                  !independentPermissions.HSE_Admin &&
                  !independentPermissions.SUPER_Admin)
              "
            >
            </p-dropdown>
            <div
              *ngIf="
                isLocationMsg && !incidentRequest.IncidentRequest.LocationId
              "
            >
              <span class="error-msg-colour">{{
                "INCIDENT.KINDLY_SELECT_LOCATION." | translate
              }}</span>
            </div>
            <div *ngIf="isInactiveLocation">
              <span class="error-msg-colour">This Location is In Active.</span>
            </div>
            <input
              type="text"
              maxlength="50"
              value=""
              class="form-control margin-top-10"
              id="name"
              [(ngModel)]="incidentRequest.IncidentRequest.SpecificLocation"
              placeholder="Specific Location"
              [disabled]="disableIncident"
            />
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.SHORT_DESCRIPTION_OF_INCIDENT" | translate }}
              <span class="mandatory">*</span>
            </span>
            <input
              type="text"
              maxlength="20"
              [(ngModel)]="incidentRequest.IncidentRequest.ShortDescription"
              class="form-control"
              id="comment"
              [disabled]="disableIncident"
            />
            <div
              *ngIf="
                isShortDescriptionMsg &&
                !incidentRequest.IncidentRequest.ShortDescription
              "
            >
              <span class="error-msg-colour"
                >Please enter short description for the incident</span
              >
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.DESCRIPTION_OF_INCIDENT" | translate }}
              <span class="mandatory">*</span>
            </span>
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="incidentRequest.IncidentRequest.DetailDescription"
              [maxLength]="1000"
              [disabled]="disableIncident"
              (output)="getRemarks($event, 'Description', 0)"
            ></ara-textarea>
            <div
              *ngIf="
                incidentRequest.IncidentRequest.DetailDescription.length >= 999
              "
            >
              <span class="error-msg-colour">
                You can enter upto 1000 characters.
              </span>
            </div>
            <div
              *ngIf="
                isDetailsDescriptionMsg &&
                !incidentRequest.IncidentRequest.DetailDescription
              "
            >
              <span class="error-msg-colour"
                >Please enter description for the incident</span
              >
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ "INCIDENT.UPLOAD_DOCUMENTS" | translate }}
            </span>
            <ara-file-upload
              [accept]="accept"
              [multiple]="multiple"
              (onInputFilesUpdatedData)="
                onInputFilesUpdated($event, 'IncidentDocument', 0)
              "
              [(inputFiles)]="incidentRequest.IncidentRequest.FileUrl"
              [disabled]="disableIncident"
            >
            </ara-file-upload>
            <ara-files-previewer [files]="incidentFiles"></ara-files-previewer>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.INITIAL_KNOWN_FACTS" | translate }}
              <span class="mandatory">*</span></span
            >
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="incidentRequest.IncidentRequest.InitalFact"
              [maxLength]="1000"
              [disabled]="disableIncident"
              (output)="getRemarks($event, 'InitialFact', 0)"
            ></ara-textarea>
            <div
              *ngIf="incidentRequest.IncidentRequest.InitalFact.length >= 999"
            >
              <span class="error-msg-colour">
                You can enter upto 1000 characters.
              </span>
            </div>
            <div
              *ngIf="
                isInitialKnownMsg && !incidentRequest.IncidentRequest.InitalFact
              "
            >
              <span class="error-msg-colour"
                >{{
                  "INCIDENT.KINDLY_ENTER_THE_INITIAL_KNOWN_FACTS." | translate
                }}
              </span>
            </div>
          </div>
          <div class="sub-section-wrapper" *ngIf="incidentType.length > 0">
            <span class="section-sub-title"
              >{{ "INCIDENT.INCIDENT_TYPE" | translate }}
              <span class="mandatory">*</span>
            </span>
            <div class="clearfix"></div>
            <div
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding"
              *ngFor="let type of incidentType"
            >
              <label>
                <input
                  type="checkbox"
                  [checked]="type.Checked"
                  [disabled]="
                    disableIncident &&
                    incidentId > 0 &&
                    !incidentPermission.INC_Admin &&
                    !incidentPermission.INC_Admin_Unit &&
                    !incidentPermission.INC_Author
                  "
                  (click)="SubmitCheckedIncidentType(type, $event)"
                  [(ngModel)]="type.Checked"
                  [value]="type"
                /><span class="incident-type-span">{{
                  type.IncidentType
                }}</span>
              </label>
            </div>
          </div>

          <div class="clearfix"></div>
          <div *ngIf="incidentTypeErrorMsg && !selectedincidentTypeId.length">
            <span class="error-msg-colour"
              >Please select at least 1 Incident Type</span
            >
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">{{
              "INCIDENT.ACTUAL_INCIDENT_SEVERITY" | translate
            }}</span>
            <span
              class="risk-matrix"
              data-toggle="modal"
              data-target="#risk-matrix"
              >RAM</span
            >
            <div class="table-responsive incident-severity-grid margin-top-10">
              <table class="table bordered">
                <thead>
                  <tr>
                    <th style="width: 10%">
                      {{ "INCIDENT.PEARN" | translate }}
                    </th>
                    <th style="width: 10%">
                      {{ "INCIDENT.SEVERITY" | translate }}
                    </th>
                    <th style="width: 19.5%">
                      {{ "INCIDENT.INCIDENT" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>People</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="disableIncident"
                        (change)="getIncidentColorClass('Incident', 'People')"
                        [(ngModel)]="PeopleIncident.PeopleIncidentSeverity"
                      >
                        <option
                          *ngFor="let severity of severityMaster"
                          Name="severity.Name"
                          value="{{ severity.Value }}"
                          [selected]="
                            PeopleIncident.PeopleIncidentSeverity === severity
                          "
                        >
                          {{ severity.Name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <span>{{ this.PeopleIncident.IncidentPeople }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Environment</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="disableIncident"
                        (change)="
                          getIncidentColorClass('Incident', 'Environment')
                        "
                        [(ngModel)]="
                          EnvironmentIncident.EnvironmentIncidentSeverity
                        "
                      >
                        <option
                          *ngFor="let severity of environmentMaster"
                          value="{{ severity.Value }}"
                          [selected]="
                            EnvironmentIncident.EnvironmentIncidentSeverity ===
                            severity
                          "
                        >
                          {{ severity.Name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <span>{{
                        this.EnvironmentIncident.IncidentEnvironment
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Assets</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="disableIncident"
                        (change)="getIncidentColorClass('Incident', 'Assets')"
                        [(ngModel)]="AssetsIncident.AssetsIncidentSeverity"
                      >
                        <option
                          *ngFor="let severity of assetsMaster"
                          value="{{ severity.Value }}"
                          [selected]="
                            AssetsIncident.AssetsIncidentSeverity === severity
                          "
                        >
                          {{ severity.Name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <span>{{ this.AssetsIncident.IncidentAssets }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Reputation</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="disableIncident"
                        (change)="
                          getIncidentColorClass('Incident', 'Reputation')
                        "
                        [(ngModel)]="
                          ReputationIncident.ReputationIncidentSeverity
                        "
                      >
                        <option
                          *ngFor="let severity of reputationMaster"
                          value="{{ severity.Value }}"
                          [selected]="
                            ReputationIncident.ReputationIncidentSeverity ===
                            severity
                          "
                        >
                          {{ severity.Name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <span>{{
                        this.ReputationIncident.IncidentReputation
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Non-Productive Time</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="disableIncident"
                        (change)="getIncidentColorClass('Incident', 'NPT')"
                        [(ngModel)]="NPTIncident.NPTIncidentSeverity"
                      >
                        <option
                          *ngFor="let severity of NPTMaster"
                          value="{{ severity.Value }}"
                          [selected]="
                            NPTIncident.NPTIncidentSeverity === severity
                          "
                        >
                          {{ severity.Name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <span>{{ this.NPTIncident.IncidentNPT }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="sub-section-wrapper"
            *ngIf="
              incidentPermission.INC_PotentialRAM ||
              incidentPermission.INC_PotentialRAM_Unit ||
              incidentPermission.INC_Admin ||
              incidentPermission.INC_Admin_Unit
            "
          >
            <span class="section-sub-title"
              >{{ "INCIDENT.POTENTIAL INCIDENT" | translate }}
            </span>
            <span
              class="risk-matrix"
              data-toggle="modal"
              data-target="#risk-matrix"
              >RAM</span
            >
            <div class="table-responsive incident-severity-grid margin-top-10">
              <table class="table bordered">
                <thead>
                  <tr>
                    <th style="width: 10%">
                      {{ "INCIDENT.PEARN" | translate }}
                    </th>
                    <th style="width: 10%">
                      {{ "INCIDENT.SEVERITY" | translate }}
                    </th>
                    <th style="width: 10%">
                      {{ "INCIDENT.LIKELIHOOD" | translate }}
                    </th>
                    <th style="width: 10%">
                      {{ "INCIDENT.RISK" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>People</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="
                          getIncidentPotentialColor('Residual', 'People')
                        "
                        [(ngModel)]="
                          PotentialPeopleIncident.PeopleIncidentSeverity
                        "
                      >
                        <ng-container *ngFor="let severity of severityMaster">
                          <option
                            *ngIf="
                              severity.Value >=
                              PeopleIncident.PeopleIncidentSeverity
                            "
                            value="{{ severity.Value }}"
                            [selected]="
                              PotentialPeopleIncident.PeopleIncidentSeverity ===
                              severity
                            "
                          >
                            {{ severity.Name }}
                          </option>
                        </ng-container>
                      </select>
                      <div
                        *ngIf="
                          !PotentialPeopleIncident.PeopleIncidentSeverity &&
                          ShowPeopleSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_SEVERITY." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="
                          getIncidentPotentialColor('Residual', 'People')
                        "
                        [(ngModel)]="
                          PotentialPeopleIncident.PeopleIncidentLikelihood
                        "
                      >
                        <option
                          *ngFor="let consequence of consequenceMaster"
                          value="{{ consequence.Value }}"
                          [selected]="
                            PotentialPeopleIncident.PeopleIncidentLikelihood ===
                            consequence
                          "
                        >
                          {{ consequence.Name }}
                        </option>
                      </select>
                      <div
                        *ngIf="
                          PotentialPeopleIncident.PeopleIncidentLikelihood ===
                            '0' && ShowPeopleSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_LIKELIHOOD." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <span
                        [ngClass]="[
                          PotentialPeopleIncident.PeopleIncidentColor !== ''
                            ? 'incident-band ' +
                              PotentialPeopleIncident.PeopleIncidentColor
                            : '',
                          PotentialPeopleIncident.PeopleIncidentColor !== ''
                            ? '' +
                              getTextClass(
                                PotentialPeopleIncident.PeopleIncidentColor
                              )
                            : ''
                        ]"
                        >{{
                          PotentialPeopleIncident.PeopleIncidentColor !== ""
                            ? getTexts(
                                PotentialPeopleIncident.PeopleIncidentColor,
                                "People"
                              )
                            : ""
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Environment</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="
                          getIncidentPotentialColor('Residual', 'Environment')
                        "
                        [(ngModel)]="
                          PotentialEnvironmentIncident.EnvironmentIncidentSeverity
                        "
                      >
                        <ng-container
                          *ngFor="let severity of environmentMaster"
                        >
                          <option
                            *ngIf="
                              severity.Value >=
                              EnvironmentIncident.EnvironmentIncidentSeverity
                            "
                            value="{{ severity.Value }}"
                            [selected]="
                              PotentialEnvironmentIncident.EnvironmentIncidentSeverity ===
                              severity
                            "
                          >
                            {{ severity.Name }}
                          </option>
                        </ng-container>
                      </select>
                      <div
                        *ngIf="
                          !PotentialEnvironmentIncident.EnvironmentIncidentSeverity &&
                          ShowEnvironmentSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_SEVERITY." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="
                          getIncidentPotentialColor('Residual', 'Environment')
                        "
                        [(ngModel)]="
                          PotentialEnvironmentIncident.EnvironmentIncidentLikelihood
                        "
                      >
                        <option
                          *ngFor="let consequence of consequenceMaster"
                          value="{{ consequence.Value }}"
                          [selected]="
                            PotentialEnvironmentIncident.EnvironmentIncidentLikelihood ===
                            consequence
                          "
                        >
                          {{ consequence.Name }}
                        </option>
                      </select>
                      <div
                        *ngIf="
                          PotentialEnvironmentIncident.EnvironmentIncidentLikelihood ===
                            '0' && ShowEnvironmentSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_LIKELIHOOD." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <span
                        [ngClass]="[
                          PotentialEnvironmentIncident.EnvironmentIncidentColor !==
                          ''
                            ? 'incident-band ' +
                              PotentialEnvironmentIncident.EnvironmentIncidentColor
                            : '',
                          PotentialEnvironmentIncident.EnvironmentIncidentColor !==
                          ''
                            ? '' +
                              getTextClass(
                                PotentialEnvironmentIncident.EnvironmentIncidentColor
                              )
                            : ''
                        ]"
                        >{{
                          PotentialEnvironmentIncident.EnvironmentIncidentColor !==
                          ""
                            ? getTexts(
                                PotentialEnvironmentIncident.EnvironmentIncidentColor,
                                "Environment"
                              )
                            : ""
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Assets</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="
                          getIncidentPotentialColor('Residual', 'Assets')
                        "
                        [(ngModel)]="
                          PotentialAssetsIncident.AssetsIncidentSeverity
                        "
                      >
                        <ng-container *ngFor="let severity of assetsMaster">
                          <option
                            *ngIf="
                              severity.Value >=
                              AssetsIncident.AssetsIncidentSeverity
                            "
                            value="{{ severity.Value }}"
                            [selected]="
                              PotentialAssetsIncident.AssetsIncidentSeverity ===
                              severity
                            "
                          >
                            {{ severity.Name }}
                          </option>
                        </ng-container>
                      </select>
                      <div
                        *ngIf="
                          !PotentialAssetsIncident.AssetsIncidentSeverity &&
                          ShowAssetsSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_SEVERITY." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="
                          getIncidentPotentialColor('Residual', 'Assets')
                        "
                        [(ngModel)]="
                          PotentialAssetsIncident.AssetsIncidentLikelihood
                        "
                      >
                        <option
                          *ngFor="let consequence of consequenceMaster"
                          value="{{ consequence.Value }}"
                          [selected]="
                            PotentialAssetsIncident.AssetsIncidentLikelihood ===
                            consequence
                          "
                        >
                          {{ consequence.Name }}
                        </option>
                      </select>
                      <div
                        *ngIf="
                          PotentialAssetsIncident.AssetsIncidentLikelihood ===
                            '0' && ShowAssetsSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_LIKELIHOOD." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <span
                        [ngClass]="[
                          PotentialAssetsIncident.AssetsIncidentColor !== ''
                            ? 'incident-band ' +
                              PotentialAssetsIncident.AssetsIncidentColor
                            : '',
                          PotentialAssetsIncident.AssetsIncidentColor !== ''
                            ? '' +
                              getTextClass(
                                PotentialAssetsIncident.AssetsIncidentColor
                              )
                            : ''
                        ]"
                        >{{
                          PotentialAssetsIncident.AssetsIncidentColor !== ""
                            ? getTexts(
                                PotentialAssetsIncident.AssetsIncidentColor,
                                "Assets"
                              )
                            : ""
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Reputation</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="
                          getIncidentPotentialColor('Residual', 'Reputation')
                        "
                        [(ngModel)]="
                          PotentialReputationIncident.ReputationIncidentSeverity
                        "
                      >
                        <ng-container *ngFor="let severity of reputationMaster">
                          <option
                            *ngIf="
                              severity.Value >=
                              ReputationIncident.ReputationIncidentSeverity
                            "
                            value="{{ severity.Value }}"
                            [selected]="
                              PotentialReputationIncident.ReputationIncidentSeverity ===
                              severity
                            "
                          >
                            {{ severity.Name }}
                          </option>
                        </ng-container>
                      </select>
                      <div
                        *ngIf="
                          !PotentialReputationIncident.ReputationIncidentSeverity &&
                          ShowReputationSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_SEVERITY." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="
                          getIncidentPotentialColor('Residual', 'Reputation')
                        "
                        [(ngModel)]="
                          PotentialReputationIncident.ReputationIncidentLikelihood
                        "
                      >
                        <option
                          *ngFor="let consequence of consequenceMaster"
                          value="{{ consequence.Value }}"
                          [selected]="
                            PotentialReputationIncident.ReputationIncidentLikelihood ===
                            consequence
                          "
                        >
                          {{ consequence.Name }}
                        </option>
                      </select>
                      <div
                        *ngIf="
                          PotentialReputationIncident.ReputationIncidentLikelihood ===
                            '0' && ShowReputationSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_LIKELIHOOD." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <span
                        [ngClass]="[
                          PotentialReputationIncident.ReputationIncidentColor !==
                          ''
                            ? 'incident-band ' +
                              PotentialReputationIncident.ReputationIncidentColor
                            : '',
                          PotentialReputationIncident.ReputationIncidentColor !==
                          ''
                            ? '' +
                              getTextClass(
                                PotentialReputationIncident.ReputationIncidentColor
                              )
                            : ''
                        ]"
                        >{{
                          PotentialReputationIncident.ReputationIncidentColor !==
                          ""
                            ? getTexts(
                                PotentialReputationIncident.ReputationIncidentColor,
                                "Reputation"
                              )
                            : ""
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Non-Productive Time</td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="getIncidentPotentialColor('Residual', 'NPT')"
                        [(ngModel)]="PotentialNPTIncident.NPTIncidentSeverity"
                      >
                        <ng-container *ngFor="let severity of NPTMaster">
                          <option
                            *ngIf="
                              severity.Value >= NPTIncident.NPTIncidentSeverity
                            "
                            value="{{ severity.Value }}"
                            [selected]="
                              PotentialNPTIncident.NPTIncidentSeverity ===
                              severity
                            "
                          >
                            {{ severity.Name }}
                          </option>
                        </ng-container>
                      </select>
                      <div
                        *ngIf="
                          !PotentialNPTIncident.NPTIncidentSeverity &&
                          ShowNPTSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_SEVERITY." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <select
                        class="form-control"
                        value="0"
                        [disabled]="
                          !incidentPermission.INC_PotentialRAM_Unit &&
                          !incidentPermission.INC_PotentialRAM &&
                          !incidentPermission.INC_Admin &&
                          !incidentPermission.INC_Admin_Unit
                        "
                        (change)="getIncidentPotentialColor('Residual', 'NPT')"
                        [(ngModel)]="PotentialNPTIncident.NPTIncidentLikelihood"
                      >
                        <option
                          *ngFor="let consequence of consequenceMaster"
                          value="{{ consequence.Value }}"
                          [selected]="
                            PotentialNPTIncident.NPTIncidentLikelihood ===
                            consequence
                          "
                        >
                          {{ consequence.Name }}
                        </option>
                      </select>
                      <div
                        *ngIf="
                          PotentialNPTIncident.NPTIncidentLikelihood === '0' &&
                          ShowNPTSeverityMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INCIDENT.KINDLY_SELECT_LIKELIHOOD." | translate
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <span
                        [ngClass]="[
                          PotentialNPTIncident.NPTIncidentColor !== ''
                            ? 'incident-band ' +
                              PotentialNPTIncident.NPTIncidentColor
                            : '',
                          PotentialNPTIncident.NPTIncidentColor !== ''
                            ? '' +
                              getTextClass(
                                PotentialNPTIncident.NPTIncidentColor
                              )
                            : ''
                        ]"
                        >{{
                          PotentialNPTIncident.NPTIncidentColor !== ""
                            ? getTexts(
                                PotentialNPTIncident.NPTIncidentColor,
                                "NPT"
                              )
                            : ""
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div
            class="sub-section-wrapper"
            *ngIf="
              incidentPermission.INC_Admin || incidentPermission.INC_Admin_Unit
            "
          >
            <label class="section-sub-title">{{
              "INCIDENT.HIGH_POTENTIAL" | translate
            }}</label>
            <label class="radio-inline">
              <input
                type="radio"
                [(ngModel)]="isHighPotential"
                value="true"
                name="whatdid"
                [disabled]="
                  disablePotential ||
                  (!incidentPermission.INC_Admin &&
                    !incidentPermission.INC_Admin_Unit)
                "
              />Yes
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                [(ngModel)]="isHighPotential"
                value="false"
                name="whatdid"
                [disabled]="
                  disablePotential ||
                  (!incidentPermission.INC_Admin &&
                    !incidentPermission.INC_Admin_Unit)
                "
              />No
            </label>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.REPORTED_TO" | translate }}
              <span class="mandatory">*</span>
            </span>
            <div class="clearfix"></div>
            <div
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 no-padding"
              *ngFor="let reportedTo of reportedToList"
            >
              <label>
                <input
                  type="checkbox"
                  [checked]="reportedTo.checked"
                  [disabled]="
                    disableIncident &&
                    incidentId > 0 &&
                    !incidentPermission.INC_Admin &&
                    !incidentPermission.INC_Admin_Unit &&
                    !incidentPermission.INC_Author
                  "
                  (click)="submitReportedTo(reportedTo, $event)"
                  [(ngModel)]="reportedTo.checked"
                  [value]="reportedTo"
                /><span class="incident-type-span">{{ reportedTo.label }}</span>
              </label>
            </div>

            <div class="clearfix"></div>
            <div *ngIf="reportingErrorMsg && !selectedReporting.length">
              <span class="error-msg-colour"
                >Please select at least 1 Reported To</span
              >
            </div>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ "INCIDENT.RATIONALE_FOR_INITIAL_CLASSIFICATION" | translate }}
              <span class="mandatory">*</span>
            </span>
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="
                incidentRequest.IncidentRequest.RationaleClassification
              "
              [maxLength]="1000"
              [disabled]="disableIncident"
              (output)="getRemarks($event, 'RationaleClassification', 0)"
            ></ara-textarea>
            <div
              *ngIf="
                incidentRequest.IncidentRequest.RationaleClassification
                  .length >= 999
              "
            >
              <span class="error-msg-colour">
                {{ "INCIDENT.YOU_CAN_ENTER_UPTO_1000_CHARACTERS" | translate }}
              </span>
            </div>
            <div
              *ngIf="
                isClassificationErrorMsg &&
                !incidentRequest.IncidentRequest.RationaleClassification
              "
            >
              <span class="error-msg-colour">{{
                "INCIDENT.KINDLY_ENTER_INITIAL_CLASSIFICATION." | translate
              }}</span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.APPOINT_CASE_OWNER" | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-autoComplete
              [(ngModel)]="selectedGeneralManager"
              [suggestions]="userResults"
              appendTo="body"
              (completeMethod)="getUsersByUsageType($event)"
              placeholder="Employee Name"
              field="FullName"
              [minLength]="1"
              [style]="{ width: '100%' }"
              [inputStyle]="{ width: '100%' }"
              [forceSelection]="true"
              [disabled]="disableIncident"
            >
              <ng-template let-employee pTemplate="item">
                <span [title]="employee.Email">{{ employee.FullName }}</span>
              </ng-template>
            </p-autoComplete>
            <span
              class="error-msg-colour"
              *ngIf="isCaseOwnerMsg && !selectedGeneralManager.UserId"
            >
              Please appoint a case owner.
            </span>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.ACTIONS_TAKEN" | translate
              }}<span class="mandatory">*</span></span
            >
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="incidentRequest.IncidentRequest.ActionTaken"
              [maxLength]="1000"
              [disabled]="disableIncident"
              (output)="getRemarks($event, 'ActionTaken', 0)"
            ></ara-textarea>
            <div
              *ngIf="incidentRequest.IncidentRequest.ActionTaken.length >= 999"
            >
              <span class="error-msg-colour">
                You can enter upto 1000 characters.
              </span>
            </div>
            <div
              *ngIf="
                isActiontakenMsg && !incidentRequest.IncidentRequest.ActionTaken
              "
            >
              <span class="error-msg-colour"
                >{{ "INCIDENT.KINDLY_ENTER_THE_ACTIONS." | translate }}
              </span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INCIDENT.IMMEDIATE_CAUSES" | translate
              }}<span class="mandatory">*</span></span
            >
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="incidentRequest.IncidentRequest.ImmediateCause"
              [maxLength]="1000"
              [disabled]="disableIncident"
              (output)="getRemarks($event, 'ImmediateCause', 0)"
            ></ara-textarea>
            <div
              *ngIf="
                incidentRequest.IncidentRequest.ImmediateCause.length >= 999
              "
            >
              <span class="error-msg-colour">
                You can enter upto 1000 characters.
              </span>
            </div>
            <div
              *ngIf="
                isCauseMsg && !incidentRequest.IncidentRequest.ImmediateCause
              "
            >
              <span class="error-msg-colour"
                >{{ "INCIDENT.KINDLY_ENTER_THE_IMMEDIATE_CAUSES." | translate }}
              </span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">{{
              "INCIDENT.INVESTIGATION_LEVELS" | translate
            }}</span>
            <p-dropdown
              [style]="{ width: '40%' }"
              [options]="investigationDetails"
              class="source-config-dropdown"
              [(ngModel)]="selectedInvestigation"
              [disabled]="disableIncident"
            >
            </p-dropdown>
          </div>
          <ara-category
            *ngIf="
              incidentPermission.INC_CAT ||
              incidentPermission.INC_CAT_Unit ||
              incidentPermission.INC_Admin ||
              incidentPermission.INC_Admin_Unit
            "
            [moduleId]="moduleId"
            [isActive]="isActive"
            [sourceId]="incidentId"
            (categoryCheckedValueEmittedData)="
              categoryCheckedEmittedValue($event)
            "
          >
          </ara-category>
          <ara-record-actions
            *ngIf="incidentId > 0"
            [SourceId]="incidentId"
            ModuleName="Incident"
            [ShowCancel]="
              (incidentPermission.INC_Admin ||
                incidentPermission.INC_Admin_Unit) &&
              incidentRequest.IncidentRequest.Status !== 'Closed' &&
              incidentRequest.IncidentRequest.Status !== 'Deleted' &&
              incidentRequest.IncidentRequest.Status !== 'Cancelled'
            "
            [ShowDelete]="
              independentPermissions.SUPER_Admin &&
              incidentRequest.IncidentRequest.Status !== 'Cancelled' &&
              incidentRequest.IncidentRequest.Status !== 'Deleted'
            "
            [ShowRestate]="
              ((incidentPermission.INC_Admin ||
                incidentPermission.INC_Admin_Unit) &&
                incidentRequest.IncidentRequest.Status === 'Cancelled') ||
              (incidentRequest.IncidentRequest.Status === 'Closed' &&
                independentPermissions.SUPER_Admin)
            "
            [Status]="incidentRequest.IncidentRequest.Status"
            (output)="getOutput($event)"
          ></ara-record-actions>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            class="section-wrapper add-action-wrapper"
            *ngIf="
              incidentId > 0 &&
              (incidentPermission.INC_Owner ||
                incidentPermission.INC_Owner_Unit ||
                incidentPermission.INC_View ||
                incidentPermission.INC_View_Unit ||
                incidentPermission.INC_Admin ||
                incidentPermission.INC_Admin_Unit ||
                incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ===
                  loggedInUserJSON.UserId) &&
              caseOwnerDetails?.length > 0
            "
          >
            <span class="section-title">{{
              "INCIDENT.CASE_OWNER_SECTION" | translate
            }}</span>
            <div class="table-responsive incident-severity-grid margin-top-10">
              <table class="table bordered">
                <thead>
                  <tr>
                    <th class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                      Process Steps
                    </th>
                    <th class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      Due Date
                    </th>
                    <th class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                      Template
                    </th>
                    <th class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                      Upload Document
                    </th>
                    <th class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                      Mark Complete
                    </th>
                  </tr>
                </thead>
                <tr *ngFor="let incident of incidentProcess; let i = index">
                  <td class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                    <label>{{ incident.IncidentProcessName }}</label>
                  </td>
                  <td class="col-lg-2 col-md-2 col-sm-2 col-xs-2 padding-right">
                    <p-calendar
                      [(ngModel)]="incident.IncidentDate"
                      dateFormat="dd/mm/yy"
                      [showIcon]="true"
                      hideOnDateTimeSelect="true"
                      [disabled]="isEnabled"
                      monthNavigator="true"
                      yearNavigator="true"
                      yearRange="1950:2100"
                      readonlyInput="true"
                    >
                    </p-calendar>
                  </td>
                  <td class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                    <button
                      type="button"
                      (click)="downloadTemplate(incident.TemplateFiles)"
                      class="active-btn orange-btn button-download-template button-pdf"
                    >
                      Download Template
                    </button>
                  </td>
                  <td class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <ara-file-upload
                      [accept]="accept"
                      [multiple]="multiple"
                      [(inputFiles)]="incident.FileUrl"
                      (onInputFilesUpdatedData)="
                        onInputFilesUpdated(
                          $event,
                          incident.IncidentProcessName,
                          i
                        )
                      "
                    >
                    </ara-file-upload>
                    <ara-files-previewer
                      [files]="incident.Files"
                    ></ara-files-previewer>
                  </td>
                  <td class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                    <input
                      type="checkbox"
                      [(ngModel)]="incident.SelectedMarkAction"
                      [disabled]="isEnabled"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            class="sub-section-wrapper add-action-wrapper"
            *ngIf="
              incidentPermission.INC_Owner ||
              incidentPermission.INC_Owner_Unit ||
              incidentPermission.INC_View ||
              incidentPermission.INC_View_Unit ||
              incidentPermission.INC_Admin ||
              incidentPermission.INC_Admin_Unit ||
              incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ===
                loggedInUserJSON.UserId ||
              !incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId
            "
          >
            <!-- <span class="section-sub-title">{{ 'INCIDENT.ADD_ACTION' | translate }}</span> -->
            <div class="table-responsive margin-bottom-20 add-action-table">
              <table
                style="align-content: center"
                class="table table-bordered table-striped table-condensed tableheader table-red"
              >
                <tbody
                  *ngFor="
                    let action of incidentActionDetailsRequest;
                    let i = index
                  "
                >
                  <tr
                    *ngIf="
                      independentPermissions.SUPER_Admin ||
                      incidentPermission.INC_Owner ||
                      incidentPermission.INC_Admin ||
                      ((incidentPermission.INC_Owner_Unit ||
                        incidentPermission.INC_View ||
                        incidentPermission.INC_View_Unit ||
                        incidentPermission.INC_Admin_Unit ||
                        incidentRequest.IncidentRequest.CaseOwnerAppointment
                          ?.UserId === loggedInUserJSON.UserId ||
                        !incidentRequest.IncidentRequest.CaseOwnerAppointment
                          ?.UserId) &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <th colspan="7" class="action-details-th">
                      <a
                        class="action-details"
                        [ngClass]="
                          action.ActionId > 0 ? 'cursor-pointer' : 'disabled'
                        "
                        (click)="
                          action.ActionId > 0
                            ? showActions(action.ActionId, action.ProcessId)
                            : $event.preventDefault()
                        "
                        ><i class="fa fa-hand-o-up"></i>
                        {{ "INCIDENT.ACTION" | translate }}
                        <ng-container *ngIf="action.ActionId > 0">{{
                          action.ActionId
                        }}</ng-container>
                      </a>
                      <span class="action-details-status">
                        <label style="margin: 0"
                          >Status :<span style="margin-left: 5px">{{
                            action.Status
                          }}</span></label
                        >
                      </span>
                    </th>
                  </tr>
                  <tr
                    *ngIf="
                      independentPermissions.SUPER_Admin ||
                      incidentPermission.INC_Owner ||
                      incidentPermission.INC_Admin ||
                      ((incidentPermission.INC_Owner_Unit ||
                        incidentPermission.INC_View ||
                        incidentPermission.INC_View_Unit ||
                        incidentPermission.INC_Admin_Unit ||
                        incidentRequest.IncidentRequest.CaseOwnerAppointment
                          ?.UserId === loggedInUserJSON.UserId ||
                        !incidentRequest.IncidentRequest.CaseOwnerAppointment
                          ?.UserId) &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <td colspan="7">
                      <ara-textarea
                        rows="4"
                        cols="30"
                        [sourceText]="action.Action"
                        [maxLength]="1000"
                        [disabled]="
                          action.Status === 'Deleted' ||
                          action.Status === 'Cancelled' ||
                          checkDisable(action.Action)
                        "
                        (output)="getRemarks($event, 'Action', i)"
                      ></ara-textarea>
                      <div
                        *ngIf="!action.Action && action.ShowActionErrorMessage"
                      >
                        <span class="error-msg-colour">{{
                          "ACTIONTRACKER.PROVIDE_ACTION_DETAILS" | translate
                        }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      independentPermissions.SUPER_Admin ||
                      incidentPermission.INC_Owner ||
                      incidentPermission.INC_Admin ||
                      ((incidentPermission.INC_Owner_Unit ||
                        incidentPermission.INC_View ||
                        incidentPermission.INC_View_Unit ||
                        incidentPermission.INC_Admin_Unit ||
                        incidentRequest.IncidentRequest.CaseOwnerAppointment
                          ?.UserId === loggedInUserJSON.UserId ||
                        !incidentRequest.IncidentRequest.CaseOwnerAppointment
                          ?.UserId) &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <td style="width: 200px">
                      <strong>Action Owner</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.ActionOwner"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionOwner($event, i)"
                        (change)="selectActionOwner($event, i)"
                        placeholder="Action Owner"
                        appendTo="body"
                        [disabled]="
                          action.Status === 'Deleted' ||
                          action.Status === 'Cancelled'
                        "
                        field="FullName"
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                      >
                        <ng-template let-actionowner pTemplate="item">
                          <span [title]="actionowner.Email">{{
                            actionowner.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                      <div *ngIf="action.ShowActionOwnerErrorMessage">
                        <span class="error-msg-colour">{{
                          "ACTIONTRACKER.KINDLY_SELECT_ACTION_OWNER" | translate
                        }}</span>
                      </div>
                    </td>
                    <td style="width: 200px">
                      <strong>Action Party</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.selectedActionParty"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionParty($event, i)"
                        [disabled]="
                          action.Status === 'Deleted' ||
                          action.Status === 'Cancelled'
                        "
                        (change)="selectActionParty($event, i)"
                        placeholder="Action Party"
                        field="FullName"
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        appendTo="body"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                      >
                        <ng-template let-actionparty pTemplate="item">
                          <span [title]="actionparty.Email">{{
                            actionparty.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                      <div
                        class="margin-top-10"
                        *ngIf="action.ShowActionPartyErrorMessage"
                      >
                        <span class="error-msg-colour">{{
                          "ACTIONTRACKER.KINDLY_SELECT_ACTION_PARTY" | translate
                        }}</span>
                      </div>
                    </td>
                    <td style="width: 200px">
                      <strong>Action Verifier</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.selectedActionVerifier"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionVerifier($event, i)"
                        (change)="selectActionVerifier($event, i)"
                        placeholder="Action Verifier"
                        field="FullName"
                        [disabled]="
                          action.Status === 'Deleted' ||
                          action.Status === 'Cancelled'
                        "
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        appendTo="body"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                      >
                        <ng-template let-actionVerifier pTemplate="item">
                          <span [title]="actionVerifier.Email">{{
                            actionVerifier.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                    </td>
                    <td style="width: 90px">
                      <strong>Priority</strong>
                      <br />
                      <select
                        class="form-control"
                        id="sel1"
                        [(ngModel)]="action.Priority"
                        [disabled]="
                          action.Status === 'Deleted' ||
                          action.Status === 'Cancelled'
                        "
                      >
                        <option [ngValue]="0">Select</option>
                        <option [ngValue]="3">High</option>
                        <option [ngValue]="2">Medium</option>
                        <option [ngValue]="1">Low</option>
                      </select>
                      <div
                        *ngIf="
                          !action.Priority && action.ShowPriorityErrorMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "ACTIONTRACKER.KINDLY_SELECT_PRIORITY" | translate
                        }}</span>
                      </div>
                    </td>
                    <td style="width: 100px">
                      <strong>Target Date</strong>
                      <br />
                      <div class="p-calendar">
                        <p-calendar
                          [showIcon]="true"
                          dateFormat="dd/mm/yy"
                          [showTime]="true"
                          placeholder=""
                          [(ngModel)]="action.TargetDate"
                          readonlyInput="true"
                          required
                          #timeOfUse="ngModel"
                          [disabled]="
                            action.Status === 'Deleted' ||
                            action.Status === 'Cancelled'
                          "
                          appendTo="body"
                          hideOnDateTimeSelect="true"
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                        >
                        </p-calendar>
                        <div *ngIf="!action.TargetDate">
                          <span class="error-msg-colour">{{
                            "ACTIONTRACKER.KINDLY_SELECT_TARGET_DATE"
                              | translate
                          }}</span>
                        </div>
                      </div>
                    </td>
                    <td style="width: 300px">
                      <ara-file-upload
                        [accept]="accept"
                        [multiple]="multiple"
                        [(inputFiles)]="action.Files"
                        [disabled]="
                          action?.Status === 'Deleted' ||
                          action?.Status === 'Closed' ||
                          action?.Status === 'Cancelled'
                        "
                      >
                      </ara-file-upload>
                      <ara-files-previewer
                        [files]="action.FilesPreview"
                      ></ara-files-previewer>
                    </td>
                    <td class="center" style="width: 50px">
                      <a
                        *ngIf="
                          action.ActionId === 0 &&
                          incidentActionDetailsRequest.length > 1
                        "
                        (click)="removeActionFromActionList(i)"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                      <a
                        (click)="cancelAssigned(action.ActionId, i)"
                        *ngIf="
                          action.Status !== 'Cancelled' &&
                          action.Status !== 'Deleted' &&
                          action.ActionId > 0 &&
                          incidentActionDetailsRequest.length > 1
                        "
                      >
                        <i
                          class="fa fa-times"
                          data-toggle="tooltip"
                          pTooltip="Cancel Action"
                          tooltipPosition="top"
                        ></i>
                      </a>
                      <a
                        (click)="deleteAssigned(action.ActionId, i)"
                        *ngIf="
                          action.Status !== 'Cancelled' &&
                          action.Status !== 'Deleted' &&
                          action.ActionId > 0 &&
                          incidentActionDetailsRequest.length > 1
                        "
                      >
                        <i
                          class="fa fa-trash"
                          data-toggle="tooltip"
                          pTooltip="Delete Action"
                          tooltipPosition="top"
                        ></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End table-responsive -->
            <a
              (click)="
                !incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ||
                incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ===
                  loggedInUserJSON.UserId ||
                incidentPermission.INC_Owner ||
                incidentPermission.INC_Owner_Unit ||
                incidentPermission.INC_Admin ||
                incidentPermission.INC_Admin_Unit
                  ? addAction()
                  : $event.preventDefault()
              "
              [ngClass]="
                !incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ||
                incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ===
                  loggedInUserJSON.UserId ||
                incidentPermission.INC_Owner ||
                incidentPermission.INC_Owner_Unit ||
                incidentPermission.INC_Admin ||
                incidentPermission.INC_Admin_Unit
                  ? 'cursor-pointer'
                  : 'disabled'
              "
              class="pull-right margin-top-10"
            >
              <i
                class="fa fa-plus"
                aria-hidden="true"
                style="padding-right: 6px"
              ></i
              >Add Action
            </a>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="breaker"></div>
        <footer>
          <a
            *ngIf="isDisplayAdd"
            routerLink="../../../home"
            class="btn btn-primary primary-btn button-float-left button-back"
            role="button"
          >
            <i class="fa fa-reply"></i>back to home
          </a>
          <a
            *ngIf="isDisplay"
            routerLink="../../incident-overview"
            class="btn btn-primary primary-btn button-back button-float-left"
            role="button"
            ><i class="fa fa-reply"></i>back to overview</a
          >
          <button
            type="button"
            *ngIf="incidentRequest.IncidentRequest.IncidentRequestId > 0"
            (click)="ReportshowDialog()"
            class="btn btn-primary primary-btn button-report-log button-float-left"
          >
            Report Log
          </button>
          <button
            type="button"
            class="btn btn-primary primary-btn button-draft"
            (click)="saveAsDraft()"
            *ngIf="
              incidentRequest.IncidentRequest.IncidentRequestId === 0 ||
              incidentRequest.IncidentRequest.Status === 'Draft'
            "
          >
            <i class="fa fa-envelope"></i>Save As Draft
          </button>
          <a
            (click)="incidentId > 0 ? downloadPDF() : $event.preventDefault()"
            [ngClass]="incidentId > 0 ? 'cursor-pointer' : 'disabled'"
            class="btn btn-primary primary-btn button-pdf"
            role="button"
          >
            <i class="fa fa-file-pdf-o"></i>Download PDF
          </a>
          <a
            *ngIf="isDisplayAdd"
            (click)="confirmResetForm()"
            class="btn btn-primary primary-btn button-reset"
            role="button"
          >
            <i class="fa fa-refresh"></i>reset
          </a>
          <a
            *ngIf="incidentRequest.IncidentRequest.IncidentRequestId === 0"
            (click)="checkValidation()"
            class="btn btn-primary primary-btn button-submit"
            role="button"
            ><i class="fa fa-share-square"></i>submit</a
          >
          <a
            *ngIf="Button.showResetButton && isDisplay"
            (click)="confirmResetForm()"
            class="btn btn-primary primary-btn"
            role="button"
            ><i class="fa fa-refresh"></i>reset</a
          >
          <a
            *ngIf="
              !isInactiveLocation &&
              isUpdateAllowed &&
              editEnabled &&
              incidentRequest.IncidentRequest.IncidentRequestId > 0 &&
              incidentRequest.IncidentRequest.Status !== 'Draft' &&
              (incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ===
                loggedInUserJSON.UserId ||
                !disableIncident ||
                incidentPermission.INC_Owner ||
                incidentPermission.INC_Owner_Unit ||
                incidentPermission.INC_PotentialRAM ||
                incidentPermission.INC_PotentialRAM_Unit ||
                incidentPermission.INC_CAT ||
                incidentPermission.INC_CAT_Unit ||
                incidentPermission.INC_Admin ||
                incidentPermission.INC_Admin_Unit)
            "
            (click)="checkValidation()"
            [ngClass]="
              incidentPermission.INC_Author === true
                ? 'disabled'
                : 'cursor-pointer'
            "
            class="btn btn-primary primary-btn button-update"
            role="button"
          >
            <i class="fa fa-share-square" pTooltip="Update Incident"></i>update
          </a>
          <a
            *ngIf="incidentRequest.IncidentRequest.Status === 'Draft'"
            (click)="checkValidation()"
            class="btn btn-primary primary-btn button-submit"
            role="button"
            ><i class="fa fa-share-square"></i>submit</a
          >
          <button
            type="button"
            class="btn btn-primary primary-btn button-close"
            *ngIf="
              incidentRequest.IncidentRequest.IncidentRequestId > 0 &&
              (incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ===
                loggedInUserJSON.UserId ||
                incidentPermission.INC_Owner ||
                incidentPermission.INC_Owner_Unit ||
                incidentPermission.INC_Admin ||
                incidentPermission.INC_Admin_Unit) &&
              incidentRequest.IncidentRequest.Status !== 'Closed'
            "
            (click)="closeIncidentRequest()"
            [disabled]="
              isShowDisabled || incidentActionDetailsRequest?.length === 0
            "
          >
            <i class="fa fa-share-square" pTooltip="Close Incident"></i>Close
          </button>
          <button
            type="button"
            class="btn btn-primary primary-btn"
            *ngIf="
              incidentRequest.IncidentRequest.IncidentRequestId > 0 &&
              (incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ===
                loggedInUserJSON.UserId ||
                incidentPermission.INC_Owner ||
                incidentPermission.INC_Owner_Unit ||
                incidentPermission.INC_Admin ||
                incidentPermission.INC_Admin_Unit) &&
              incidentRequest.IncidentRequest.Status === 'Closed'
            "
            (click)="closeIncidentRequest()"
            [disabled]="
              isShowDisabled || incidentActionDetailsRequest?.length === 0
            "
          >
            <i class="fa fa-star" pTooltip="Incident Rating"></i>Incident Rating
          </button>
        </footer>
      </div>
    </div>
    <ara-alerts
      [alertType]="alertType"
      [successDetails]="successDetails"
      [errorDetails]="errorDetails"
      [warningMessage]="warningMessage"
      (okClicked)="onOkClickedForConfirmation()"
      [confirmMessage]="confirmMessage"
      (yesClicked)="onYesClickedForConfirmation()"
      (noClicked)="onNoClickedForConfirmation()"
    ></ara-alerts>
    <div class="clearfix"></div>
    <span *ngIf="ReportclosePopup">
      <p-dialog
        header="Report History"
        [(visible)]="ReportclosePopup"
        (onHide)="ReportclosePopUp()"
        [modal]="true"
      >
        <ara-report-log
          [ReportUserId]="ReportUserId"
          [ReportModule]="ReportModule"
          [ReportRecordId]="ReportRecordId"
        >
        </ara-report-log>
      </p-dialog>
    </span>
  </div>
</div>
<div class="clearfix"></div>
<div class="modal fade" id="risk-matrix" role="dialog">
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close button-cancel" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title custom_align" id="Heading">
          Risk Assessment Matrix
        </h4>
      </div>
      <div class="modal-body">
        <img class="ram-img" src="assets/images/incident-ram.png" />
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>

<p-dialog
  header="Incident Rating"
  [(visible)]="ratingdialog"
  modal="modal"
  width="1024"
>
  <table
    class="table table-bordered table-striped table-condensed tableheader table-red"
  >
    <thead>
      <tr>
        <th rowspan="2">Assesment Criteria</th>
        <th rowspan="2">Purpose</th>
        <th colspan="4">Scores 0-3</th>
        <th rowspan="2" width="100px">Rate</th>
      </tr>
      <tr>
        <th>
          0<br />
          Not Evident
        </th>
        <th>
          1<br />
          Inconsistent, poor quality
        </th>
        <th>
          2<br />
          Consistent, must improve
        </th>
        <th>
          3<br />
          Consistent, good quality
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Potential Assessment</td>
        <td>ARA line determines whether an incident has a high potential</td>
        <td>
          No assessment made of the potential consequences of an incident by ARA
          line management
        </td>
        <td>Assessment at location only, and not challenged up the line</td>
        <td>Assessment at location and challenged up the line</td>
        <td>
          Assessment at location and challenged up the line up to the General
          Manager
        </td>
        <td>
          <p-dropdown
            [style]="{ width: '100%' }"
            [options]="ratings"
            [(ngModel)]="incidentRating.PotentialAssessment"
            [disabled]="
              incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId !==
                loggedInUserJSON.UserId &&
              !incidentPermission.INC_Owner &&
              !incidentPermission.INC_Owner_Unit &&
              !incidentPermission.INC_Admin &&
              !incidentPermission.INC_Admin_Unit
            "
          >
          </p-dropdown>
        </td>
      </tr>
      <tr>
        <td>Terms of Reference</td>
        <td>
          Plan a quality incident investigation: scope, timeline, team & level
          of investigation
        </td>
        <td>No Terms of Reference</td>
        <td>
          Investigation initiated with no incident specific Terms of Reference
        </td>
        <td>
          Investigation initiated with incident specific instruction but not
          challenged and agreed by the line
        </td>
        <td>
          Investigation initiated with incident specific Terms of Reference
          agreed up the line (including the General Manager and corporate HSSE
          for high risk incidents)
        </td>
        <td>
          <p-dropdown
            [style]="{ width: '100%' }"
            [options]="ratings"
            [(ngModel)]="incidentRating.TermsOfReference"
            [disabled]="
              incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId !==
                loggedInUserJSON.UserId &&
              !incidentPermission.INC_Owner &&
              !incidentPermission.INC_Owner_Unit &&
              !incidentPermission.INC_Admin &&
              !incidentPermission.INC_Admin_Unit
            "
          >
          </p-dropdown>
        </td>
      </tr>
      <tr>
        <td>Follow-up Execution</td>
        <td>
          (i) Incident investigation executed as per or better Terms of
          Reference. (ii) Ensure incident investigation is tracked to support
          the investigation process and enhance learning
        </td>
        <td>No investigation or incident close-out</td>
        <td>
          Investigation has not followed Terms of Reference or not tracked to
          close out
        </td>
        <td>
          Investigation completed largely as per terms of reference; with scope
          to improve investigation process, tracking, monitoring and recording.
        </td>
        <td>
          Investigation executed as per terms of reference, process tracked
          weekly by the line & in the field (and by senior management for high
          risk incidents). Incident follow-up formally recorded in field and
          company records.
        </td>
        <td>
          <p-dropdown
            [style]="{ width: '100%' }"
            [options]="ratings"
            [(ngModel)]="incidentRating.FollowUpExecution"
            [disabled]="
              incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId !==
                loggedInUserJSON.UserId &&
              !incidentPermission.INC_Owner &&
              !incidentPermission.INC_Owner_Unit &&
              !incidentPermission.INC_Admin &&
              !incidentPermission.INC_Admin_Unit
            "
          >
          </p-dropdown>
        </td>
      </tr>
      <tr>
        <td>Investigation Quality</td>
        <td>
          Quality investigation undertaken at the level required by the Terms of
          Reference, refered to Appendix 1 of Incident follow-up framework, and
          see sheet '3-Investigation levels'
        </td>
        <td>No investigation notification and / or completed investigation</td>
        <td>
          Investigation incomplete not all elements addressed with appropriate
          quality and / or coherence
        </td>
        <td>
          Investigation covers all elements and is considered complete but has
          some recognised weaknesses
        </td>
        <td>
          Investigation covers all elements and is considered to be complete in
          its findings and recommendations, technically correct, in its
          conclusions, analysis and recommendations.
        </td>
        <td>
          <p-dropdown
            [style]="{ width: '100%' }"
            [options]="ratings"
            [(ngModel)]="incidentRating.InvestigationQuality"
            [disabled]="
              incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId !==
                loggedInUserJSON.UserId &&
              !incidentPermission.INC_Owner &&
              !incidentPermission.INC_Owner_Unit &&
              !incidentPermission.INC_Admin &&
              !incidentPermission.INC_Admin_Unit
            "
          >
          </p-dropdown>
        </td>
      </tr>
      <tr>
        <td>Field review</td>
        <td>
          Line management close out incident investigation with formal review
          and agree SMART recommendations
        </td>
        <td>No review of the investigation outcomes</td>
        <td>
          Review at location only and, little attention to investigation quality
          and the practicality on investigation recommendations
        </td>
        <td>
          Management challenge and review not complete, or action follow-up not
          formally agreed or resourced
        </td>
        <td>
          Management challenged investigation quality and decided, agreed and
          resourced follow-up in formal close-out.
        </td>
        <td>
          <p-dropdown
            [style]="{ width: '100%' }"
            [options]="ratings"
            [(ngModel)]="incidentRating.FieldReview"
            [disabled]="
              incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId !==
                loggedInUserJSON.UserId &&
              !incidentPermission.INC_Owner &&
              !incidentPermission.INC_Owner_Unit &&
              !incidentPermission.INC_Admin &&
              !incidentPermission.INC_Admin_Unit
            "
          >
          </p-dropdown>
        </td>
      </tr>
      <tr>
        <td>Management review</td>
        <td>
          (i) to give signficant incidents high level attention within the
          company. (ii) Assure quality of incident investigation in ARA. (iii)
          Provide support as necessary
        </td>
        <td>
          No review by senior management of the investigation quality against 5
          criteria above and the management of the process
        </td>
        <td>
          Coast not involved sufficently early in the incident investigation
          process to be able to adequately monitor, contribute, influence or
          assure as appropriate
        </td>
        <td>
          Management review takes place in a timely fashion and it is agreed
          with the incident incident owner that incident close-out could be
          signficantly improved
        </td>
        <td>
          Investigation reviewed by senior management and field and formally
          closed out; Where necessary further follow-up determined and agreed;
          further causal analysis or specific further investigation in-depth
          considered
        </td>
        <td>
          <p-dropdown
            [style]="{ width: '100%' }"
            [options]="ratings"
            [(ngModel)]="incidentRating.ManagementReview"
            [disabled]="
              incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId !==
                loggedInUserJSON.UserId &&
              !incidentPermission.INC_Owner &&
              !incidentPermission.INC_Owner_Unit &&
              !incidentPermission.INC_Admin &&
              !incidentPermission.INC_Admin_Unit
            "
          >
          </p-dropdown>
        </td>
      </tr>
    </tbody>
  </table>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="ratingdialog = false"
      label="Cancel"
      class="active-btn orange-btn"
    ></button>
    <button
      type="button"
      pButton
      *ngIf="
        incidentRequest.IncidentRequest.IncidentRequestId > 0 &&
        (incidentRequest.IncidentRequest.CaseOwnerAppointment?.UserId ===
          loggedInUserJSON.UserId ||
          incidentPermission.INC_Owner ||
          incidentPermission.INC_Owner_Unit ||
          incidentPermission.INC_Admin ||
          incidentPermission.INC_Admin_Unit)
      "
      (click)="CloseIncidentWithRating()"
      label="Close Incident"
      class="active-btn orange-btn"
    ></button>
  </p-footer>
</p-dialog>
